import { ref } from 'vue';
export const isCrmmAdmin = ref(false);
let loaded = false;
export async function loadIsCrmmAdmin() {
  if (loaded) return isCrmmAdmin.value;
  loaded = true;
  try {
    const accountId = window.location.pathname.split('/')[3];
    const res = await window.axios.get('/api/v1/accounts/' + accountId + '/crmm/config');
    isCrmmAdmin.value = !!(res.data && res.data.crmm_admin);
  } catch (e) { isCrmmAdmin.value = false; }
  return isCrmmAdmin.value;
}
// chamadas super-admin: o Rails valida crmm_super_admin? e injeta o admin_token server-side.
export async function crmmAdminApi(feature, body) {
  const accountId = window.location.pathname.split('/')[3];
  const res = await window.axios.post('/api/v1/accounts/' + accountId + '/crmm/admin/' + feature, body || {});
  return res.data === '' ? null : res.data;
}
